import { render, staticRenderFns } from "./Signage.vue?vue&type=template&id=13b1afe5&scoped=true&"
import script from "./Signage.vue?vue&type=script&lang=js&"
export * from "./Signage.vue?vue&type=script&lang=js&"
import style0 from "./Signage.vue?vue&type=style&index=0&id=13b1afe5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b1afe5",
  null
  
)

export default component.exports